/**
 * AnalyseIATab — insights générés par Claude, un par bloc.
 *
 * Phase 3 (cf. docs/fiche-v2-plan.md) :
 *   A. ✅ Synthèse exécutive — shipped (Phase 3A)
 *   F. ✅ Red flags — shipped (Phase 3F)
 *   D. ✅ Estimation de prix — shipped (Phase 3D)
 *   B. ✅ Potentiel d'agrandissement — shipped (Phase 3B)
 *   C. ✅ Analyse visuelle multimodale — shipped (Phase 3C)
 *
 * Chaque bloc a sa propre Cloud Function et sa propre sous-collection
 * `/users/{uid}/fiches/{id}/ai/{blockId}` écrite côté serveur via Admin SDK
 * (rules : read owner-only, write false côté client). Regen silencieuse sur
 * changement structurel (hash des inputs — fiche seule pour synthèse,
 * fiche + env pour red flags et estimation, + DVF médiane pour estimation,
 * + footprint BD TOPO pour potentiel, + lat/lng bucket + sv-availability
 * pour visuel).
 */

import type { FicheDoc } from "../lib/fiches";
import { SyntheseCard } from "./ai/SyntheseCard";
import { RedFlagsCard } from "./ai/RedFlagsCard";
import { EstimationCard } from "./ai/EstimationCard";
import { PotentielCard } from "./ai/PotentielCard";
import { VisuelCard } from "./ai/VisuelCard";

export function AnalyseIATab({ fiche }: { fiche: FicheDoc }) {
  return (
    <div className="py-4 space-y-4">
      {/* Hero : synthèse exécutive en 3-4 phrases. */}
      <SyntheseCard ficheId={fiche.id} />

      {/* Red flags — liste triée par sévérité. */}
      <RedFlagsCard ficheId={fiche.id} />

      {/* Estimation de prix — fourchette DVF + modifiers env. Reçoit la
          fiche entière parce que la card lit aussi la carte des loyers
          (commune-level) pour calculer un rendement brut potentiel. */}
      <EstimationCard fiche={fiche} />

      {/* Potentiel d'agrandissement — CES × parcelle × bâti BD TOPO. */}
      <PotentielCard ficheId={fiche.id} />

      {/* Analyse visuelle — orthophoto IGN + Street View + Claude multimodal. */}
      <VisuelCard ficheId={fiche.id} />
    </div>
  );
}
